export const ENTITY_TYPES = {
  ACCOUNT: "Account",
  ASSIGNMENT: "Assignment",
  ATTEMPT: "Attempt",
  COMMUNITY: "Community",
  HOME: "Home",
  ISSUE: "Issue",
  ORDER: "Order",
  ORDER_TEMPLATE: "OrderTemplate",
  PRODUCT: "Product",
  PURCHASE_ORDER: "PurchaseOrder",
  STEP: "Step",
  TASK: "Task",
  WORK_ORDER: "WorkOrder",
  INSPECTION: "Inspection",
  INVOICE: "Invoice",
};

export const ENTITY_NAMES = {
  ACCOUNT: "Account",
  ACCOUNTS: "Accounts",
  ASSIGNMENT: "Assignment",
  ASSIGNMENTS: "Assignments",
  ATTEMPT: "Attempt",
  ATTEMPTS: "Attempts",
  BID_REQUEST: "Bid Request",
  BID_REQUESTS: "Bid Requests",
  BUILD_TEMPLATE: "Build Type",
  BUILD_TEMPLATES: "Build Types",
  BUILDER: "Builder",
  BUILDERS: "Builders",
  COMMUNITIES: "Communities",
  COMMUNITY: "Community",
  EMAIL_TEMPLATE: "Email Template", // these will stay as "Template" on the UI
  EMAIL_TEMPLATES: "Email Templates",
  HOME: "Home",
  HOMES: "Homes",
  INSPECTION_TEMPLATE: "Inspection Type",
  INSPECTION_TEMPLATES: "Inspection Types",
  INSPECTION: "Inspection",
  INSPECTIONS: "Inspections",
  INVOICE: "Invoice",
  INVOICES: "Invoices",
  ISSUE_TEMPLATE: "Issue Type",
  ISSUE_TEMPLATES: "Issue Types",
  ISSUE: "Issue",
  ISSUES: "Issues",
  ORDER_TEMPLATE: "Order Type",
  ORDER_TEMPLATES: "Order Types",
  ORDER: "Order",
  ORDERS: "Orders",
  PRODUCT: "Product",
  PRODUCTS: "Products",
  PURCHASE_ORDER: "Purchase Order",
  PURCHASE_ORDERS: "Purchase Orders",
  STEP_TEMPLATE: "Step Type",
  STEP_TEMPLATES: "Step Types",
  STEP: "Step",
  STEPS: "Steps",
  TASK: "Task",
  TASKS: "Tasks",
  WORK_ORDER_TEMPLATE: "Work Order Type",
  WORK_ORDER_TEMPLATES: "Work Order Types",
  WORK_ORDER: "Work Order",
  WORK_ORDERS: "Work Orders",
  WORK_ORDER_STEPS: "Work Order Steps",
};

export const ENTITY_TYPE_LABELS = {
  [ENTITY_TYPES.ACCOUNT]: ENTITY_NAMES.ACCOUNT,
  [ENTITY_TYPES.ASSIGNMENT]: ENTITY_NAMES.ASSIGNMENT,
  [ENTITY_TYPES.ATTEMPT]: ENTITY_NAMES.ATTEMPT,
  [ENTITY_TYPES.COMMUNITY]: ENTITY_NAMES.COMMUNITY,
  [ENTITY_TYPES.HOME]: ENTITY_NAMES.HOME,
  [ENTITY_TYPES.ISSUE]: ENTITY_NAMES.ISSUE,
  [ENTITY_TYPES.ORDER]: ENTITY_NAMES.ORDER,
  [ENTITY_TYPES.ORDER_TEMPLATE]: ENTITY_NAMES.ORDER_TEMPLATE,
  [ENTITY_TYPES.PRODUCT]: ENTITY_NAMES.PRODUCT,
  [ENTITY_TYPES.PURCHASE_ORDER]: ENTITY_NAMES.PURCHASE_ORDER,
  [ENTITY_TYPES.STEP]: ENTITY_NAMES.STEP,
  [ENTITY_TYPES.TASK]: ENTITY_NAMES.TASK,
  [ENTITY_TYPES.WORK_ORDER]: ENTITY_NAMES.WORK_ORDER,
  [ENTITY_TYPES.INSPECTION]: ENTITY_NAMES.INSPECTION,
  [ENTITY_TYPES.INVOICE]: ENTITY_NAMES.INVOICE,
};

export const ENTITY_TYPES_OPTIONS = [
  {
    value: ENTITY_TYPES.ACCOUNT,
    label: ENTITY_TYPE_LABELS[ENTITY_TYPES.ACCOUNT],
  },
  {
    value: ENTITY_TYPES.ASSIGNMENT,
    label: ENTITY_TYPE_LABELS[ENTITY_TYPES.ASSIGNMENT],
  },
  {
    value: ENTITY_TYPES.ATTEMPT,
    label: ENTITY_TYPE_LABELS[ENTITY_TYPES.ATTEMPT],
  },
  {
    value: ENTITY_TYPES.COMMUNITY,
    label: ENTITY_TYPE_LABELS[ENTITY_TYPES.COMMUNITY],
  },
  { value: ENTITY_TYPES.HOME, label: ENTITY_TYPE_LABELS[ENTITY_TYPES.HOME] },
  { value: ENTITY_TYPES.ISSUE, label: ENTITY_TYPE_LABELS[ENTITY_TYPES.ISSUE] },
  { value: ENTITY_TYPES.ORDER, label: ENTITY_TYPE_LABELS[ENTITY_TYPES.ORDER] },
  {
    value: ENTITY_TYPES.ORDER_TEMPLATE,
    label: ENTITY_TYPE_LABELS[ENTITY_TYPES.ORDER_TEMPLATE],
  },
  {
    value: ENTITY_TYPES.PRODUCT,
    label: ENTITY_TYPE_LABELS[ENTITY_TYPES.PRODUCT],
  },
  {
    value: ENTITY_TYPES.PURCHASE_ORDER,
    label: ENTITY_TYPE_LABELS[ENTITY_TYPES.PURCHASE_ORDER],
  },
  { value: ENTITY_TYPES.STEP, label: ENTITY_TYPE_LABELS[ENTITY_TYPES.STEP] },
  { value: ENTITY_TYPES.TASK, label: ENTITY_TYPE_LABELS[ENTITY_TYPES.TASK] },
  {
    value: ENTITY_TYPES.WORK_ORDER,
    label: ENTITY_TYPE_LABELS[ENTITY_TYPES.WORK_ORDER],
  },
];
